import addAccordionSupport from '../../../core/js/uiSupport/accordion';
import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';

/**
 * Attach component events to DOM
 * @param {object} store - The store
 * @returns {undefined}
 */
export function attachEvents(store) {
    function getOffsetHeaderValue() {
        const $brandsHeaderList = $('.js-brands-list');

        return $('.js-global-header-wrap').outerHeight() + $brandsHeaderList.outerHeight(true);
    }

    function getBrandIndexPosition(e) {
        const brandIndexName = $(e.target).attr('data-brand-index');

        return $(`[data-brand-name="${brandIndexName}"]`).offset().top;
    }

    const offsetHeaderValue = getOffsetHeaderValue();

    $(document).on('click', '.js-brands-header-link', (e) => {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: getBrandIndexPosition(e) - offsetHeaderValue
        }, 500);
    });
}

function afterConstruction(store) {
    addAccordionSupport(this, this.templateLocation);
}

/**
 * Bootstrap the component onto the page
 * @param {object} store - The store
 * @param {object} overrides - The overrides object
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        children: [],
        templateLocation: '.dom-brands-index',
        name: 'brandsIndexComponent',
        attachEvents: attachEvents,
        afterConstruction: afterConstruction
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
